import AnimatedText from 'react-animated-text-content';
import { Col, Container, Row } from 'react-bootstrap';
import Gobbo from '../../assets/images/team/01.png';
import Fabio from '../../assets/images/team/02.png';
import Collins from '../../assets/images/team/collins.jpg';
import David from '../../assets/images/team/david.jpeg';
import Frank from '../../assets/images/team/frank.jpg';

import { Linkedin } from 'react-bootstrap-icons';
import './team.css';


const TEAM_CEO = [
  
  {
    id: 't2',
    name: 'Fabio Spina',
    role: 'Founder',
    img: Fabio,
    LinkedInUrl: 'https://www.linkedin.com/in/fabio-spina-16a046187',
    LinkedInIcon: <Linkedin className='team-social' />,
    description: 'Fabio Spina is a founder of Kutee Kitty and a blockchain enthusiast with expertise in NFTs.',
  },
  {
    id: 't1',
    name: 'Cristian Del Gobbo',
    role: 'Founder',
    img: Gobbo,
    LinkedInUrl: 'https://www.linkedin.com/in/cristiandelgobbo',
    LinkedInIcon: <Linkedin className='team-social' />,
    description: 'Fabio Spina is a founder of Kutee Kitty and a blockchain enthusiast with expertise in NFTs.',
  },
];


const TEAM_DATA = [
  {
    id: 't1',
    name: 'Collins Esq.',
    // role: 'Founder',
    img: Collins,
    LinkedInUrl: 'https://www.linkedin.com/in/collinsdelpercio',
    LinkedInIcon: <Linkedin className='team-social' />,
    description: 'Collins brings his legal analysis and cryptocurrency knowledge to the project.',
  },
  {
    id: 't2',
    name: 'David B.',
    // role: 'Founder',
    img: David,
    LinkedInUrl: 'https://www.linkedin.com/in/davidbruce31',
    LinkedInIcon: <Linkedin className='team-social' />,
    description: 'David brings his technological and communication experience to the project.',
  },
  {
    id: 't3',
    name: 'Frank C.',
    // role: 'Content creator',
    img: Frank,
    LinkedInUrl: 'https://www.linkedin.com/in/frank-calabrese-8b960067',
    LinkedInIcon: <Linkedin className='team-social' />,
    description: 'Frank brings his knowledge of cryptocurrency and NFT project management to the project.',
  },
];

const Team = () => {
  const teamContent = (
    <>
      <Container fluid className='np nm team__main__container'>
        <Container className='team__container'>
          <Row>
            <Col>
              <h1 className='team__h1 animate__animated animate__bounce animate__faster'>
                <AnimatedText
                  type='chars' // animate words or chars
                  animation={{
                    x: '200px',
                    y: '-30px',
                    scale: 1.1,
                    ease: 'ease-in-out',
                  }}
                  animationType='throw'
                  interval={0.06}
                  duration={1}
                  tag='p'
                  className='animated-paragraph'
                  includeWhiteSpaces
                  threshold={0.1}
                  rootMargin='20%'
                >
                  OUR TEAM
                </AnimatedText>
              </h1>
            </Col>
          </Row>

          <Row className='ceo-row'>

          {TEAM_CEO.map(team => {
              return (
                // <Col md={3}></Col>
                <Col md={4}>
                  <div className='team__box' key={team.id}>
                    <img src={team.img} alt='' className='team__col' />
                    <p className='team__box__p1'> {team.name} </p>
                    <p className='team__box__p2'>
                      {team.role}
                      <a
                        href={team.LinkedInUrl}
                        rel='noreferrer'
                        target='_blank'
                      >
                        <span>{team.LinkedInIcon}</span>
                      </a>
                    </p>
                    <p className='description'>
                      {team.description}
                    </p>
                  </div>
                </Col>
              );
            })}
            </Row>

            <Row className='ceo-row'>

            {TEAM_DATA.map(team => {
              return (
                <Col md={3}>
                  <div className='team__box' key={team.id}>
                    <img src={team.img} alt='' className='team__col' />
                    <p className='team__box__p1'> {team.name} </p>
                    <p className='team__box__p2'>
                      <a
                        href={team.LinkedInUrl}
                        rel='noreferrer'
                        target='_blank'
                      >
                        <span>{team.LinkedInIcon}</span>
                      </a>
                    </p>
                    <p className='description'> 
                      {team.description}
                    </p>
                  </div>
                </Col>
              );
            })}

            

          </Row>

          <div>
          <p className='bottom__p__box'>
          These are the American portion of the Team behind the project. They bring legal, technical, and business management experience to the team.
          </p>
        </div>

        
        </Container>
      </Container>
    </>
  );

  return <div>{teamContent}</div>;
};

export default Team;